import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Accordion } from 'semantic-ui-react';
import AccordionHeader from '@/components/accordion/AccordionHeader';

const DatasetAttachmentsAccordion = ({
  active,
  canUpload,
  canUpdate,
  children,
  onClick,
}) => (
  <>
    <AccordionHeader
      active={active}
      headerId="dataset.attachments"
      onClick={onClick}
      className="aridhia-dataset-attachments-accordion"
    >
      {(canUpload || canUpdate) && (
      <span className="normal">
        <FormattedMessage id="dataset.attachments.description" />
      </span>
      )}
    </AccordionHeader>
    {active && (<Accordion.Content active={active}>{children}</Accordion.Content>)}
  </>
);

export default DatasetAttachmentsAccordion;
